import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  path?: string;
  image?: string;
  type?: "website" | "article";
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
  noindex?: boolean;
}

/**
 * Título, descrição, canonical e Open Graph são definidos por rota
 * (head() de cada arquivo em src/routes) para funcionarem no SSR.
 * Este componente cuida apenas do JSON-LD específico de cada página.
 */
export function SEO({ jsonLd, noindex = false }: SEOProps) {
  const ldArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      {noindex && <meta name="robots" content="noindex, follow" />}
      {ldArray.map((ld, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(ld)}
        </script>
      ))}
    </Helmet>
  );
}
